import React from "react";
import Wip from "../../Wip";
import { useTheme } from "../../../../common/hooks";
import "./content.css";
import { useTranslation } from "react-i18next";
import { hobbiesInfo } from "../../../../constants/hobbies";
import { AdhesiveTapeImage } from "../../Image/AdhesiveTapeImage/AdhesiveTapeImage";
import classnames from "classnames";
import { themeKeys } from "../../../../constants/themes";

export default function HobbyContent(props) {
  const { hobby } = props;
  const { image } = hobbiesInfo[hobby];
  const { t } = useTranslation();
  const { themeKey } = useTheme();
  const parragraphs = t(`hobbies.${hobby}.text`, {
    returnObjects: true,
  });

  if (!hobbiesInfo[hobby]) {
    return <Wip />;
  }

  return (
    <div
      className={classnames("hobby-container", {
        dark: themeKey === themeKeys.DARK,
      })}
    >
      <AdhesiveTapeImage
        {...image}
        src={`/images/hobbies/${image.src}`}
        className="hobby-image"
      />

      <div className="hobby-text">
        <h1>{t(`hobbies.${hobby}.title`)}</h1>
        {parragraphs.map((parragraph) => (
          <p>{parragraph}</p>
        ))}
      </div>
    </div>
  );
}
